<div id="mypv-support-widget" class="support-widget" [class.support-widget--expanded]="state === 'expanded'" [class.support-widget--mia]="state === 'mia'" [class.support-widget--contact]="state === 'contact'" role="complementary" aria-label="Soporte MY Posventa">
  <div class="support-widget__panel" *ngIf="showPanel && (miaAvailable || contactAvailable)" [@loadedHeightAnimation]="'visible'">
    <button type="button" class="support-widget__panel-close" (click)="closePanel()" aria-label="Cerrar menú de soporte">
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='currentcolor'>
        <path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414' />
      </svg>
    </button>

    <header class="support-widget__panel-header">
      <h2 class="support-widget__panel-title">¿Necesitas ayuda?</h2>
      <p class="support-widget__panel-subtitle">Elige la opción de soporte que mejor encaje contigo.</p>
    </header>

    <button type="button" class="support-widget__option" *ngIf="miaAvailable" (click)="onMiaClick()">
      <img class="support-widget__option-icon" src="assets/images/support-widget/icon-mia.svg" alt="MIA" width="47" height="47">
      <span class="support-widget__option-body">
        <span class="support-widget__option-title">MIA</span>
        <span class="support-widget__option-text">Resuelve tus dudas al instante con nuestro asistente inteligente</span>
      </span>
      <img class="support-widget__option-chevron" src="assets/images/support-widget/icon-chevron.svg" alt="Abri chat con MIA" width="13" height="24">
    </button>

    <button type="button" class="support-widget__option" *ngIf="contactAvailable" (click)="onContactClick()">
      <img class="support-widget__option-icon envelope" src="assets/images/support-widget/icon-envelope.svg" alt="Consulta general" width="43" height="32">
      <span class="support-widget__option-body">
        <span class="support-widget__option-title">Consulta general</span>
        <span class="support-widget__option-text">Gestiona consultas a través de nuestro equipo de soporte</span>
      </span>
      <img class="support-widget__option-chevron" src="assets/images/support-widget/icon-chevron.svg" alt="Abrir consulta con soporte" width="13" height="24">
    </button>
  </div>

  <div class="support-widget__actions">
    <div class="support-widget__tip" *ngIf="showTip" (click)="onFabClick()" [@loadedWidthAnimation]="'visible'" role="status">
      <button type="button" class="support-widget__tip-close" (click)="dismissTip($event)" aria-label="Cerrar consejo">
        <div class="support-widget__tip-close-icon">
          <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='currentcolor'>
            <path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414' />
          </svg>
        </div>
      </button>
      <div class="support-widget__tip-text">
        <p class="support-widget__tip-title">¿Necesitas ayuda?</p>
        <p class="support-widget__tip-subtitle">Soporte técnico, comercial y operativo</p>
      </div>
    </div>

    <button type="button" class="support-widget__fab" (click)="onFabClick()" [attr.aria-label]="isExternalWidgetOpen ? 'Cerrar soporte y abrir menú' : (showPanel ? 'Cerrar menú de soporte' : 'Abrir menú de soporte')" [attr.aria-expanded]="showPanel || isExternalWidgetOpen">
      <img class="support-widget__fab-icon" src="assets/images/support-widget/icon-headset.svg" alt="Abrir menú de soporte" width="48" height="48">
    </button>
  </div>
</div>
